// extracted by mini-css-extract-plugin
export default {"text":"HandWrittenText_text__ATBMU","isRegular":"HandWrittenText_isRegular__XHvlO","isSmall":"HandWrittenText_isSmall__p9qPV","invisibleText":"HandWrittenText_invisibleText__C-h9V"};